import React, { Component } from "react";
import Paper from "material-ui/Paper";
import { FormattedMessage } from "react-intl";
import { getFvContract, getPlan, checkJapanese, getToken, copyWebinarPublisherUrl, copyHostURL, copyWebinarURL, getURL, checkIOS } from "../../lib";
import RaisedButton from "material-ui/RaisedButton";
import SessionsRoom from "./SessionsRoom";
import SessionsRoomMobile from "./SessionsRoomMobile";
import { Redirect } from "react-router-dom";
import CreateAndEditRoom from "./CreateNEditRoom";
import SendEmailDialog from "./SendEmailDialog";
import NotificationSystem from 'react-notification-system'
import { createGoogleCalendarEvent } from "../../lib/googleCalendar";
import config from "../../config/config";
import RoomOptions from "./RoomOptions";

class SeminarTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
      alreadyCreatedRooms: [],
      index_0: "#4688F1",
      index_1: "#afb8c5",
      room_name: "",
      payed: true,
      fvroom_name: "",
      max_room_num_per_user: "",
      domain_id: "",
      domainUrlName: "",
      admin_guest_url: "",
      domainType: "",
      domainInvalidStatus: false,
      roomNameLengthError: false,
      openRoomModal: false,
      isEdit: false,
      selectedRoom: {},
      openSendEmailDialog: false,
      sendEmailTo: {},
      selectedRoomHostURl: '',
      selectedRoomGuestURL: '',
      showRoomOptions: false,
      selectedRoomForOptions: null,
      isRoomUpdated: false,
    };
  }


  async componentDidMount() {
    const res = await getFvContract();
    if (res.status && res.status === "success") {
      const isWebinar = window.location.pathname.indexOf("/admin/webinar") > -1;
      if (!res.data.domain.enable_webinar && isWebinar) {
        window.location.href = "/";
        return false;
      }

      if (!res.data.domain.enable_conference && !isWebinar) {
        window.location.href = "/admin/webinar";
        return false;
      }

      this.setState({
        fv_domains_name: res.data.domain.fv_domains_name,
        max_room_num_per_user: res.data.domain.max_room_num_per_user,
        domain_id: res.data.domain.id,
        domainUrlName: res.data.domain.fv_domains_name,
        domainType: res.data.domain.fvdomain_type,
        admin_guest_url: res.data.domain.admin_guest_url,
      });
      this.getRoom();
      this.fetchAddressBook()
      if (res.data.expire_flag && res.data.account === "admin") {
        let warning = checkJapanese()
          ? "アカウントの有効期限が切れています。管理者に相談してください。"
          : "Your account has expired. Consult your administrator.";
        alert(warning);
      } else if (res.data.status === "invalid") {
        this.setState({
          domainInvalidStatus: true,
        });
        let warning = checkJapanese()
          ? "アカウントが無効です。管理者に相談してください。"
          : "Account is invalid. Consult your administrator.";
        alert(warning);
      } else if (
        res.data.expire_flag === null &&
        res.data.account === "free_admin"
      ) {
      }
    }
  }

  joinRoom = () => {
    if (!this.state.room_name || this.state.room_name.length == 0) {
      let warning = checkJapanese()
        ? "部屋の名前を入力してください"
        : "Please enter a room name";
      alert(warning);
      return;
    }
    if (window.location.hostname == "admin.dd-talk.net") {
      window.open("https://dd-talk.net/" + this.state.room_name);
    } else {
      window.open("https://video-dev.dd-talk.net/" + this.state.room_name);
    }
  };

  getRoom = async () => {
    const isWebinar = window.location.pathname.indexOf("/admin/webinar") > -1;
    const res = await getPlan(isWebinar ? 1 : 0);
    if (res.data.hasOwnProperty("rooms")) {
      this.setState({
        rooms: res.data.rooms,
        alreadyCreatedRooms: res.data.rooms.length,
        payed: this.state.domain_id ? true : false,
      });
    }
  };

  fetchAddressBook = () => {
    this.props.fetchEmailAddressBook(getToken());
    this.props.fetchGroups(getToken());
  }

  editRoom = (room) => {
    this.setState(
      {
        selectedRoom: room,
        isEdit: true,
      },
      () => {
        this.setState({
          openRoomModal: true,
        });
      }
    );
  };

  handleInvitationEmail = (room, hostURL, guestURL) => {
    console.log(room);
    this.setState({ sendEmailTo: room, selectedRoomHostURl: hostURL, selectedRoomGuestURL: guestURL }, () => {
      this.setState({ openSendEmailDialog: true });
    })
  }

  showSuccessNotification = (message, level) => {
    const notification = this.refs.notificationSystem;
    notification.addNotification({
      message,
      level,
      position: 'tr',
      autoDismiss: 60
    })
  }

  openGoogleCalendar = (data, isWebinar) => {
    let room = data;
    console.log(room);
    const hostURL = isWebinar ? copyWebinarPublisherUrl(room, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url)  : copyHostURL(room, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url);
    console.log(hostURL);
    room.url = hostURL
    room.isWebinar = isWebinar;
    createGoogleCalendarEvent(room);
  }

  onRoomCreate = (data, isAdded) => {
    this.getRoom();
    this.setState({ openRoomModal: false });
    if(data) {
      this.setState({ showRoomOptions: true, selectedRoomForOptions: data, isRoomUpdated: !isAdded });
    }
  }

  sendInvitation = () => {
    const isWebinar = window.location.pathname.indexOf("/admin/webinar") > -1;
    const hostURL = isWebinar 
      ? copyWebinarPublisherUrl(this.state.selectedRoomForOptions, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url) 
      : copyHostURL(this.state.selectedRoomForOptions, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url);

    const guestURL = isWebinar 
      ? copyWebinarURL(this.state.selectedRoomForOptions.fvroom_name, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url) 
      : getURL(this.state.selectedRoomForOptions.fvroom_name, this.state.domainUrlName, this.state.domainType, this.state.admin_guest_url);

    
    this.handleInvitationEmail(this.state.selectedRoomForOptions, hostURL, guestURL);
    setTimeout(this.closeRoomOptionDialog, 1000);
  }

  addToGoogleCalendar = () => {
    if(checkIOS()) {
      this.showGoogleCalendarNotAvailable();
      return;
    }
    this.openGoogleCalendar(this.state.selectedRoomForOptions, window.location.pathname.indexOf("/admin/webinar") > -1);
    console.log(this.state.selectedRoomForOptions);
    setTimeout(this.closeRoomOptionDialog, 1000);
  }

  closeRoomOptionDialog = () => {
    this.setState({ showRoomOptions: false, selectedRoomForOptions: null });
  }

  showGoogleCalendarNotAvailable = () => {
    alert(
      checkJapanese() 
      ? "Googleカレンダー登録はPC（Chrome、Edge）からご利用ください。" 
      : "Google Calendar integration is only available in Chrome and Edge from Desktop. Please try again."
    );
  }

  render() {
    if (this.state.domainInvalidStatus) {
      return <Redirect to="/admin/settings/manage-plans" />;
    }
    let sessionRoom;
    if (this.state.payed) {
      if (this.props.view === "sm-mobile" || this.props.view === "mobile") {
        sessionRoom = (
          <SessionsRoomMobile
            rooms={this.state.rooms}
            getRoom={this.getRoom}
            domainUrlName={this.state.domainUrlName}
            domainType={this.state.domainType}
            admin_guest_url={this.state.admin_guest_url}
            view={this.props.view}
            isWebinar={window.location.pathname.indexOf("/admin/webinar") > -1}
            editRoom={this.editRoom}
            handleInvitationEmail={this.handleInvitationEmail}
          />
        );
      } else {
        sessionRoom = (
          <SessionsRoom
            rooms={this.state.rooms}
            getRoom={this.getRoom}
            domainUrlName={this.state.domainUrlName}
            domainType={this.state.domainType}
            admin_guest_url={this.state.admin_guest_url}
            view={this.props.view}
            isWebinar={window.location.pathname.indexOf("/admin/webinar") > -1}
            editRoom={this.editRoom}
            handleInvitationEmail={this.handleInvitationEmail}
          />
        );
      }
    }
    return (
      <Paper style={{ borderRight: "2px solid #e3e3e3", padding: "10px" }}>
        <div className="inivitation-notification"><NotificationSystem  ref="notificationSystem" /></div>
        {this.state.showRoomOptions && this.state.selectedRoomForOptions && (
          <RoomOptions 
            handleClose={this.closeRoomOptionDialog} 
            sendInvitation={this.sendInvitation}
            addToGoogleCalendar={this.addToGoogleCalendar}
            isRoomUpdated={this.state.isRoomUpdated}
          />
        )}

        {this.state.openSendEmailDialog && (
          <SendEmailDialog 
            open={this.state.openSendEmailDialog}
            handleClose={() => {
              this.setState({ openSendEmailDialog: false });
            }}
            onSend={(message, level) => {
              this.setState({ openSendEmailDialog: false });
              this.showSuccessNotification(message, level);
            }}
            addressBook={this.props.emailAddressBook}
            groups={this.props.groups}
            sendEmailTo={this.state.sendEmailTo}
            hostURL={this.state.selectedRoomHostURl}
            guestURL={this.state.selectedRoomGuestURL}
            user={this.props.user}
            isWebinar={window.location.pathname.indexOf("/admin/webinar") > -1}
            onAddEmailAddress={() => {
              this.props.fetchEmailAddressBook(getToken());
            }}
          />
        )}

        {this.state.openRoomModal && (
          <CreateAndEditRoom
            isWebinar={window.location.pathname.indexOf("/admin/webinar") > -1}
            open={this.state.openRoomModal}
            handleClose={() => {
              this.setState({
                openRoomModal: false,
                isEdit: false,
                selectedRoom: {},
              });
            }}
            isEdit={this.state.isEdit}
            selectedRoom={this.state.selectedRoom}
            totalRooms={this.state.rooms.length}
            alreadyCreatedRooms={this.state.alreadyCreatedRooms}
            max_room_num_per_user={this.state.max_room_num_per_user}
            onClose={this.onRoomCreate}
            domainUrlName={this.state.domainUrlName}
            view={this.props.view}
          />
        )}

        <RaisedButton
          onTouchTap={() =>
            this.state.payed
              ? this.setState({
                  openRoomModal: true,
                  isEdit: false,
                  selectedRoom: {},
                })
              : this.joinRoom()
          }
          backgroundColor="#60d1bd"
          labelStyle={{ color: "#fff" }}
          className="create-btn"
          label={
            this.state.payed ? (
              <FormattedMessage id="roomList.createNewRoom" />
            ) : (
              <FormattedMessage id="loggedInNavigation.enterRoom" />
            )
          }
          style={{ height: 42, margin: "10px 0", minWidth: '180px' }}
        />
        <RaisedButton
          onTouchTap={() => {
            this.props.history.push({
              pathname: '/admin/invitations',
              state: { isWebinar: window.location.pathname.indexOf("/admin/webinar") > -1}
            });
          }}
          className="email-invite-btn"
          label={<FormattedMessage id="emailAddressBook.invitationHistory" />}
          backgroundColor="#60d1bd"
          labelStyle={{ color: "#fff" }}
          style={{ height: 42, margin: "10px 0", marginLeft: '12px', minWidth: '180px' }}
        />
        {sessionRoom}
      </Paper>
    );
  }
}

export default SeminarTabs;



// WEBPACK FOOTER //
// src/components/Seminars/Seminars.js